import {Component} from '@angular/core';
import {NavParams} from "ionic-angular";
import {ModalNavPage} from "../../pages/modal-nav/modal-nav";
import {AutoUnsubscribe} from "ngx-auto-unsubscribe";
import {NoteService} from "../../store/note/note.service";
import {ProtocolService} from "../../store/protocol/protocol.service";

/**
 * Generated class for the BemerkungstextvorlagenComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@AutoUnsubscribe()
@Component({
  selector: 'anmerkungstextvorlagen',
  templateUrl: 'anmerkungstextvorlagen.html'
})
export class AnmerkungstextvorlagenComponent {

  public vorlagen: Array<{title: string, category: string}>;
  public selectedVorlage: string = null;
  private protocol: any;

  constructor(private modalNav: ModalNavPage,
              private navParams: NavParams,
              public noteService: NoteService,
              private protocolService: ProtocolService) {
    this.selectedVorlage = this.navParams.get('selectedVorlage');
    this.protocol = this.navParams.get('rootElement');
  }

  public closeModal(): void {
    this.modalNav.dismissModal();
  }

  public select(vorlage: {title: string, category: string}): void {
    this.selectedVorlage = vorlage.title;
  }

  public back(): void {
    this.selectedVorlage = null;
  }

  public add(): void {
    if(!this.protocol.comments){
      this.protocol.comments = [];
    }
    this.protocol.comments.push(this.selectedVorlage);
    this.protocolService.set(this.protocol, false);
    this.modalNav.dismissModal();
  }

  public save(): void {

    const doc = {
      docType: "note",
      docName: "Anmerkung",
      title: this.selectedVorlage,
      category: null,
      system: false,
    };
    this.noteService.add(doc, false);
    this.selectedVorlage = null;
  }

  public newAnmerkung():void {
    this.selectedVorlage = "";
  }

  // If you work with AOT this method must be present, even if empty!
  // Otherwise 'ng build --prod' will optimize away any calls to ngOnDestroy,
  // even if the method is added by the @AutoUnsubscribe decorator
  ngOnDestroy() {
    // You can also do whatever you need here
  }
}



// WEBPACK FOOTER //
// ./src/components/anmerkungstextvorlagen/anmerkungstextvorlagen.ts